import type { ReceptionistSettingsPageId } from './types';

export interface ReceptionistSettingsNavItem {
  id: ReceptionistSettingsPageId;
  label: string;
  group: 'Setup' | 'Behavior' | 'Channels';
}

export const RECEPTIONIST_SETTINGS_NAV: ReceptionistSettingsNavItem[] = [
  { id: 'personality', label: 'Personality & character', group: 'Setup' },
  { id: 'knowledge', label: 'Knowledge base', group: 'Setup' },
  { id: 'capabilities', label: 'Capabilities', group: 'Setup' },
  { id: 'emergency', label: 'Emergency detection', group: 'Behavior' },
  { id: 'practiceRules', label: 'Practice rules', group: 'Behavior' },
  { id: 'compliance', label: 'Compliance', group: 'Behavior' },
  { id: 'call', label: 'Call', group: 'Channels' },
  { id: 'sms', label: 'SMS', group: 'Channels' },
  { id: 'email', label: 'Email', group: 'Channels' },
  { id: 'chat', label: 'Chat', group: 'Channels' },
];

export function settingsLabelForPage(id: ReceptionistSettingsPageId): string {
  return RECEPTIONIST_SETTINGS_NAV.find((item) => item.id === id)?.label ?? 'Settings';
}
